var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { KtsDateTimeService, PickerOptions } from './datetime.service';
var KtsTimeComponent = /** @class */ (function (_super) {
    __extends(KtsTimeComponent, _super);
    function KtsTimeComponent(service, baseService, datetimeService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.datetimeService = datetimeService;
        _this.datetimeFlg = false; // controlType: datetime の時間選択で使うときtrue
        _this.defOptions = new PickerOptions();
        _this.addOptions = {};
        _this.close = true;
        _this.isMobile = false;
        _this.formatMobile = 'H:i';
        _this.valMobile = '';
        _this.minTimeMobile = '';
        _this.maxTimeMobile = '';
        _this.isMobile = _this.datetimeService.isMobile();
        return _this;
    }
    KtsTimeComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.msg) {
            this.defOptions = this.datetimeService.getDefOptions(this.col, this.msg);
            if (this.defOptions.minDate && !this.defOptions.minTime) {
                if (this.datetimeFlg) {
                    this.minDate = flatpickr.parseDate(this.defOptions.minDate, this.defOptions.formats.format);
                }
                else {
                    this.defOptions.minTime = this.defOptions.minDate;
                }
            }
            if (this.defOptions.minTime) {
                this.minTime = flatpickr.parseDate(this.defOptions.minTime, this.defOptions.dateFormat);
            }
            delete this.defOptions.minDate;
            if (this.defOptions.maxDate && !this.defOptions.maxTime) {
                if (this.datetimeFlg) {
                    this.maxDate = flatpickr.parseDate(this.defOptions.maxDate, this.defOptions.formats.format);
                }
                else {
                    this.defOptions.maxTime = this.defOptions.maxDate;
                }
            }
            if (this.defOptions.maxTime) {
                this.maxTime = flatpickr.parseDate(this.defOptions.maxTime, this.defOptions.dateFormat);
            }
            delete this.defOptions.maxDate;
        }
        if (changes.col) {
            var from = jsonpath.value(this.col, '$.params.range.from');
            var to = jsonpath.value(this.col, '$.params.range.to');
            if (from && to) {
                this.fromKey = this.baseService.getColKey(this.componentName, from, this.index);
                this.toKey = this.baseService.getColKey(this.componentName, to, this.index);
            }
        }
        if (changes.val || changes.datetimeVal) {
            if (this.isMobile) {
                if (this.val) {
                    this.valMobile = flatpickr.formatDate(flatpickr.parseDate(this.val, this.defOptions.dateFormat), this.formatMobile);
                }
                else {
                    this.valMobile = this.val;
                }
            }
            this.setVal();
        }
    };
    KtsTimeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsTimeComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.element = this.timeElement.nativeElement;
        if (this.isMobile) {
            $(this.element).on('click', function () {
                var mode = (_this.colKey === _this.fromKey ? "from" /* from */ : (_this.colKey === _this.toKey ? "to" /* to */ : null));
                _this.setTime(_this.fromKey, _this.toKey, mode);
                _this.minTimeMobile = _this.addOptions.minTime ? flatpickr.formatDate(_this.addOptions.minTime, _this.formatMobile) : '';
                _this.maxTimeMobile = _this.addOptions.maxTime ? flatpickr.formatDate(_this.addOptions.maxTime, _this.formatMobile) : '';
            });
            $(this.element).on('change', function () {
                if (_this.valMobile) {
                    var time = flatpickr.formatDate(flatpickr.parseDate(_this.valMobile, _this.formatMobile), _this.defOptions.dateFormat);
                    _super.prototype.onChange.call(_this, time);
                }
                else {
                    var val = '';
                    if (_this.datetimeFlg) {
                        if (_this.minTimeMobile) {
                            val = _this.minTimeMobile;
                        }
                        else {
                            var date = new Date();
                            date.setHours(_this.defOptions.defaultHour || 0, _this.defOptions.defaultMinute || 0, 0, 0);
                            val = flatpickr.formatDate(date, _this.formatMobile);
                        }
                        _this.valMobile = val; // ngOnChanges()が呼ばれないことがあるのでここでセットする
                        var time = flatpickr.formatDate(flatpickr.parseDate(val, _this.formatMobile), _this.defOptions.dateFormat);
                        _super.prototype.onChange.call(_this, time);
                        return;
                    }
                    _super.prototype.onChange.call(_this, val);
                }
            });
        }
    };
    KtsTimeComponent.prototype.setVal = function () {
        if (this.element && this.val) {
            var mode = (this.colKey === this.fromKey ? "from" /* from */ : (this.colKey === this.toKey ? "to" /* to */ : null));
            this.setTime(this.fromKey, this.toKey, mode);
        }
        else if (this.picker) {
            this.picker.clear();
        }
    };
    KtsTimeComponent.prototype.setDateTimePicker = function () {
        var _this = this;
        var self = this;
        if (this.fromKey && this.toKey) {
            // 開始日
            if (this.colKey === this.fromKey) {
                this.picker = flatpickr(this.element, Object.assign({}, this.defOptions, this.addOptions, {
                    onClose: function (selectedDates, dateStr, instance) {
                        self.close = true;
                        _super.prototype.onChange.call(_this, dateStr);
                    },
                    onChange: function (selectedDates, dateStr, instance) {
                        self.close = true;
                        _super.prototype.onChange.call(_this, dateStr);
                    }
                }));
            }
            // 終了日
            if (this.colKey === this.toKey) {
                this.picker = flatpickr(this.element, Object.assign({}, this.defOptions, this.addOptions, {
                    onClose: function (selectedDates, dateStr, instance) {
                        self.close = true;
                        _super.prototype.onChange.call(_this, dateStr);
                    },
                    onChange: function (selectedDates, dateStr, instance) {
                        self.close = true;
                        _super.prototype.onChange.call(_this, dateStr);
                    }
                }));
            }
        }
        else {
            this.picker = flatpickr(this.element, Object.assign({}, this.defOptions, this.addOptions, {
                onClose: function (selectedDates, dateStr, instance) {
                    self.close = true;
                    _super.prototype.onChange.call(_this, dateStr);
                },
                onChange: function (selectedDates, dateStr, instance) {
                    self.close = true;
                    _super.prototype.onChange.call(_this, dateStr);
                }
            }));
        }
    };
    KtsTimeComponent.prototype.setTime = function (from, to, mode) {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        var currentDate = null;
        if (this.minDate || this.maxDate) {
            currentDate = flatpickr.parseDate($('input[name="' + this.colKey.replace('$time.', '$date.') + '"]').val(), this.defOptions.formats.formatDate);
        }
        // Min
        var minTime = null;
        if (this.minTime) {
            minTime = new Date(this.minTime.getTime());
            minTime.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        }
        var minDate = null;
        if (this.minDate) {
            var _minDate = new Date(this.minDate.getTime());
            _minDate.setHours(0, 0, 0, 0);
            if (currentDate && _minDate && currentDate.getTime() <= _minDate.getTime()) {
                minDate = new Date(this.minDate.getTime());
                minDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
            }
            else {
                minDate = null;
            }
        }
        var fromDate = null;
        if (mode === "to" /* to */) {
            fromDate = this.getMinOrMaxTime(from, to, mode);
            if (fromDate) {
                fromDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
            }
        }
        var targetMinDate = null;
        if (minTime) {
            targetMinDate = minTime;
        }
        else if (minDate) {
            targetMinDate = minDate;
        }
        if ((!targetMinDate && fromDate) || (targetMinDate && fromDate && targetMinDate.getTime() < fromDate.getTime())) {
            targetMinDate = fromDate;
        }
        this.addOptions.minTime = targetMinDate;
        if (!targetMinDate) {
            targetMinDate = date;
        }
        // Max
        var maxTime = null;
        if (this.maxTime) {
            maxTime = new Date(this.maxTime.getTime());
            maxTime.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        }
        var maxDate = null;
        if (this.maxDate) {
            var _maxDate = new Date(this.maxDate.getTime());
            _maxDate.setHours(0, 0, 0, 0);
            if (currentDate && _maxDate && currentDate.getTime() >= _maxDate.getTime()) {
                maxDate = new Date(this.maxDate.getTime());
                maxDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
            }
            else {
                maxDate = null;
            }
        }
        var toDate = null;
        if (mode === "from" /* from */) {
            toDate = this.getMinOrMaxTime(from, to, mode);
            if (toDate) {
                toDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
            }
        }
        var targetMaxDate = null;
        if (maxTime) {
            targetMaxDate = maxTime;
        }
        else if (maxDate) {
            targetMaxDate = maxDate;
        }
        if ((!targetMaxDate && toDate) || (targetMaxDate && toDate && targetMaxDate.getTime() > toDate.getTime())) {
            targetMaxDate = toDate;
        }
        this.addOptions.maxTime = targetMaxDate;
        var defDate = targetMinDate;
        if (this.val) {
            var val = flatpickr.parseDate(this.val, this.defOptions.dateFormat);
            val.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
            if (targetMinDate.getTime() < val.getTime()) {
                defDate = val;
            }
            if (targetMaxDate && targetMaxDate.getTime() < val.getTime()) {
                defDate = targetMaxDate;
            }
        }
        var time = flatpickr.formatDate(defDate, this.defOptions.dateFormat);
        this.addOptions.defaultDate = time;
        if (this.val !== time) {
            _super.prototype.onChange.call(this, time);
        }
    };
    KtsTimeComponent.prototype.getMinOrMaxTime = function (from, to, mode) {
        var returnVal = false;
        if (this.datetimeFlg) {
            // controlType: datetime
            var fromDateVal = flatpickr.parseDate($('input[name="' + from.replace('$time.', '$date.') + '"]').val(), this.defOptions.formats.formatDate);
            var toDateVal = flatpickr.parseDate($('input[name="' + to.replace('$time.', '$date.') + '"]').val(), this.defOptions.formats.formatDate);
            if (fromDateVal && toDateVal && fromDateVal.getTime() >= toDateVal.getTime()) {
                returnVal = true;
            }
        }
        else {
            // controlType: time
            returnVal = true;
        }
        if (returnVal) {
            if (mode === "from" /* from */) {
                return flatpickr.parseDate($('input[name="' + to + '"]').val(), this.defOptions.dateFormat);
            }
            else if (mode === "to" /* to */) {
                return flatpickr.parseDate($('input[name="' + from + '"]').val(), this.defOptions.dateFormat);
            }
        }
        return null;
    };
    KtsTimeComponent.prototype.onClick = function (e) {
        if (!this.close) {
            return;
        }
        // flatpickrの数が多いと動作が遅くなるのでクリック時に生成する
        this.dir.addErrors(this.err || []); // flatpickrを開くときに値がセットされるので必須エラーを非表示にする
        this.close = false;
        var mode = (this.colKey === this.fromKey ? "from" /* from */ : (this.colKey === this.toKey ? "to" /* to */ : null));
        this.setTime(this.fromKey, this.toKey, mode);
        this.setDateTimePicker();
        this.picker.open();
    };
    KtsTimeComponent.prototype.onDelete = function (e) {
        _super.prototype.onChange.call(this, '');
    };
    KtsTimeComponent.prototype.ngAfterViewChecked = function () {
        if (this.picker) {
            var cls = this.element.className;
            if (this.close && !cls.match(/active/)) {
                // flatpickrの数が多いと動作が遅くなるので時間選択後に削除する
                var val = this.val;
                this.picker.destroy();
                this.picker = null;
                // destroy()を行うと設定がクリアされてしまうので再設定する
                this.element.value = val;
                this.element.setAttribute('readonly', 'true');
                this.element.classList.add('flatpickr-input');
            }
        }
        if (this.isMobile && this.datetimeFlg && this.val && !this.valMobile) {
            // モバイルで値をクリアしたとき、changeイベントが呼ばれないことがあるので手動で呼ぶ
            $(this.element).trigger('change');
        }
    };
    KtsTimeComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.picker) {
            this.picker.destroy();
        }
    };
    KtsTimeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-time',
                    template: "\n        <ng-template [ngIf]=\"!isMobile\">\n            <input type=\"time\" step=\"60\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" class=\"flatpickr-input\"\n                   [disabled]=\"datetimeFlg && !val\" [readOnly]=\"true\" [placeholder]=\"col\"\n                   [(ngModel)]=\"val\" [key]=\"key\" [col]=\"col\" columnDir #time (click)=\"onClick($event)\">\n            <a *ngIf=\"!datetimeFlg && val\" href=\"javascript:void(0);\" (click)=\"onDelete($event)\"\n               style=\"position: absolute; right: 8px;\" [style.bottom]=\"key === 'forminline' ? '4px' : '8px'\">\n                <img alt=\"\" src=\"img/icon_delete.svg\" width=\"18\">\n            </a>\n        </ng-template>\n        <ng-template [ngIf]=\"isMobile\">\n            <input type=\"time\" step=\"60\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\"\n                   [min]=\"minTimeMobile\" [max]=\"maxTimeMobile\" [disabled]=\"datetimeFlg && !valMobile\" [placeholder]=\"col\"\n                   [(ngModel)]=\"valMobile\" [key]=\"key\" [col]=\"col\" columnDir #time>\n        </ng-template>\n    "
                }] }
    ];
    /** @nocollapse */
    KtsTimeComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsDateTimeService }
    ]; };
    KtsTimeComponent.propDecorators = {
        datetimeFlg: [{ type: Input }],
        datetimeVal: [{ type: Input }],
        timeElement: [{ type: ViewChild, args: ['time',] }]
    };
    return KtsTimeComponent;
}(ColumnBaseComponent));
export { KtsTimeComponent };
//# sourceMappingURL=time.component.js.map